import React from 'react';
import WorkedDaysLabel from "./WorkedDaysLabel";

const displayWorkedDays = (workedDays, sameDateMultiplePractices) => {
    if (sameDateMultiplePractices && sameDateMultiplePractices.length === 0) {
        return workedDays;
    } else {
        return (
            <WorkedDaysLabel
                workedDays={workedDays}
                sameDateMultiplePractices={sameDateMultiplePractices}
            />
        );
    }
}

export default displayWorkedDays;